import { render, staticRenderFns } from "./cl-people-with-team.vue?vue&type=template&id=87134794&scoped=true"
import script from "./cl-people-with-team.vue?vue&type=script&lang=js"
export * from "./cl-people-with-team.vue?vue&type=script&lang=js"
import style0 from "./cl-people-with-team.vue?vue&type=style&index=0&id=87134794&prod&lang=scss&scoped=true"
import style1 from "./cl-people-with-team.vue?vue&type=style&index=1&id=87134794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87134794",
  null
  
)

export default component.exports